// Function loadMyAccountUpdateProfilePage loads the MyAccountUpdateProfilePage class by dynamically importing the js on demand if needed

export function loadMyAccountUpdateProfilePage($parentEl, isList = false) {

	return import('../widgets/myAccountUpdateProfilePage').then(wg => {

		const { MyAccountUpdateProfilePage } = wg;

		let $wg = $parentEl.querySelector('[data-pg="MyAccountUpdateProfilePage"]');

		if(!$wg) {
			//console.info('MyAccountUpdateProfilePage: no widget found');
			return null;
		}

		if (isList) {
			
			let $wgCol = $parentEl.querySelectorAll('[data-pg="MyAccountUpdateProfilePage"]');
			let instances = [];
			$wgCol.forEach(($wg, i) => {
				instances.push( new MyAccountUpdateProfilePage($wg) );
			});
			if (instances.length === $wgCol.length) return instances;

		} else {
			return new MyAccountUpdateProfilePage($wg);
		}


	}).catch(error => error+'An error occurred while loading the MyAccountUpdateProfile Page');

}
